import { useCallback, useRef, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { formatMedicare, formatPhone } from "../../helpers";
import { Clinic, Patient } from "../../models";
import { ConfirmAddBannedPatient } from "../BannedPatients";
import { FromPage } from "../../pages/PatientSearch";

interface props {
	patients: Patient[];
	clinic?: Clinic;
	fromPage?: FromPage;
	searchCompleted: boolean;
	closeSearch: (updated: boolean) => void;
	canSelectPatient: (patient: Patient) => Promise<boolean>;
}
export const PatientTable = ({
	patients,
	clinic,
	fromPage,
	searchCompleted,
	closeSearch,
	canSelectPatient
}: props) => {
	const [selectedPatient, setSelectedPatient] = useState<Patient | undefined>(
		undefined
	);
	const [openConfirmAdd, setOpenConfirmAdd] = useState(false);
	const checkingPatient = useRef(false);
	const [isCheckingPatient, setIsCheckingPatient] = useState(false);

	const handleClick = useCallback(
		async (patient: Patient) => {
			if (checkingPatient.current) return;
			checkingPatient.current = true;
			setIsCheckingPatient(true);
			try {
				if (await canSelectPatient(patient)) {
					setSelectedPatient(patient);
					setOpenConfirmAdd(true);
				}
			} finally {
				checkingPatient.current = false;
				setIsCheckingPatient(false);
			}
		},
		[canSelectPatient]
	);

	const closeConfirmAdd = useCallback(
		(updated: boolean) => {
			console.info("SearchPatientTable closeConfirmAdd", updated);
			setOpenConfirmAdd(false);
			closeSearch(updated);
		},
		[closeSearch]
	);

	return (
		<>
			{isCheckingPatient && (
				<div className="flex items-center justify-center gap-2" role="status">
					<CircularProgress size={24} />
					Checking banned patient status...
				</div>
			)}
			{!searchCompleted && <div className="ch-mtext">Enter patient name</div>}

			{searchCompleted && patients.length === 0 && (
				<div className="ch-mtext">
					There aren't any patients matching your search criteria
				</div>
			)}
			{searchCompleted && patients.length > 0 && (
				<>
					<table className="ch-table ch-table-selectable w-full">
						<thead>
							<tr>
								<th scope="col" style={{ width: "5%" }}></th>
								<th scope="col">Id</th>
								<th scope="col">Patient Name</th>
								<th scope="col">DOB</th>
								<th scope="col">Phone</th>
								<th scope="col">Medicare</th>
								<th scope="col">IRN</th>
								<th scope="col">Expiry</th>
							</tr>
						</thead>
						<tbody>
							{patients.map((patient) => (
								<tr key={patient.id} onClick={() => handleClick(patient)}>
									<td>{/* <Checkbox /> */}</td>
									<td>{patient.bpId}</td>
									<td>{`${patient.firstName} ${patient.surname}`}</td>
									<td>{patient.dateOfBirth}</td>
									<td>{formatPhone(patient.phoneNumber)}</td>
									<td>{formatMedicare(patient.medicareNumber)}</td>
									<td>{patient.medicareLineNo}</td>
									<td>{patient.medicareExpiry}</td>
								</tr>
							))}
						</tbody>
					</table>
					{selectedPatient && fromPage === FromPage.BannedPatient && (
						<ConfirmAddBannedPatient
							open={openConfirmAdd}
							patient={selectedPatient as Patient}
							clinic={clinic}
							onClose={closeConfirmAdd}
						/>
					)}
				</>
			)}
		</>
	);
};
